import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL, fetchJson, readStoredUser, refreshStoredUser } from '../../utils/auth';

const PirateCharacterSheet = () => {
  const [resolvedRole, setResolvedRole] = useState('viewer');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const navigate = useNavigate();
  const apiUrl = encodeURIComponent(API_URL);
  const iframeRef = useRef(null);

  useEffect(() => {
    let ignore = false;
    const storedUser = readStoredUser();

    if (!storedUser) {
      setResolvedRole('viewer');
      return () => {
        ignore = true;
      };
    }

    async function refreshCurrentUserRole() {
      try {
        const refreshedUser = await refreshStoredUser();

        if (!ignore && refreshedUser) {
          const { response, payload } = await fetchJson('/pirate-system/access', {
            method: 'GET',
          });

          if (!ignore && response.ok) {
            setResolvedRole(payload.access?.role || 'viewer');
            return;
          }

          if (!ignore) {
            setResolvedRole(refreshedUser.role === 'owner' ? 'owner' : 'viewer');
          }
        }
      } catch (_error) {
        if (!ignore) {
          setResolvedRole(readStoredUser()?.role === 'owner' ? 'owner' : 'viewer');
        }
      }
    }

    refreshCurrentUserRole();

    return () => {
      ignore = true;
    };
  }, []);

  useEffect(() => {
    function handleThemeMessage(event) {
      if (event.source !== iframeRef.current?.contentWindow) return;
      if (event.data?.type !== 'pirate-character-sheet-theme') return;
      setIsDarkMode(Boolean(event.data.darkMode));
    }

    window.addEventListener('message', handleThemeMessage);
    return () => window.removeEventListener('message', handleThemeMessage);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100dvh',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={() => navigate('/projects/Pirate')}
        style={{
          position: 'absolute',
          top: '8px',
          left: '12px',
          zIndex: 1000,
          minWidth: '104px',
          padding: '9px 14px',
          border: isDarkMode
            ? '1px solid rgba(118, 140, 176, 0.2)'
            : '1px solid rgba(217, 187, 121, 0.45)',
          borderRadius: '6px',
          background: isDarkMode ? 'rgba(20, 25, 35, 0.94)' : 'rgba(47, 36, 23, 0.92)',
          color: isDarkMode ? '#e8edf6' : '#f6edd7',
          cursor: 'pointer',
          fontFamily: '"Trebuchet MS", sans-serif',
          fontSize: '0.92rem',
          fontWeight: 700,
          boxSizing: 'border-box',
          boxShadow: isDarkMode
            ? '0 8px 20px rgba(3, 6, 12, 0.32)'
            : '0 8px 20px rgba(47, 36, 23, 0.18)',
        }}
      >
        &lt; Back
      </button>

      <iframe
        ref={iframeRef}
        src={`/games/PirateSystem/PirateCharacterSheet.html?role=${encodeURIComponent(resolvedRole)}&apiUrl=${apiUrl}`}
        title="Pirate Character Sheet"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    </div>
  );
};

export default PirateCharacterSheet;
